import { sendNotificationResponse } from "@/entities/notification"
import { userKeys } from "@/entities/user"
import { inviteFriend } from "@/features/invite-friend"
import * as m from "@/paraglide/messages"
import {
	registerNotification,
	releaseNotificationId,
} from "@/shared/api/websocket"
import { isSystemPopupOpen, showSystemPopup } from "@/shared/lib/platform"

registerNotification("subscription", {
	handle: async ({ notification_id, data }, ctx) => {
		ctx.queryClient.invalidateQueries({ queryKey: userKeys.byId(ctx.userId) })

		// Another system popup holds the screen: this one is never shown, so there
		// is nothing to answer and the server replays it.
		if (isSystemPopupOpen()) {
			releaseNotificationId(notification_id)
			return
		}

		switch (data.type) {
			case "7_days_reward": {
				await showSystemPopup({
					title: m.inviteSubBonusTitle(),
					message: m.inviteSubBonusMessage(),
					buttons: [{ id: "ok", text: m.inviteSubBonusBtnOk() }],
				})
				sendNotificationResponse("subscription", "closed", notification_id)
				break
			}

			case "7_days_reward_expired": {
				const buttonId = await showSystemPopup({
					title: m.inviteSubExpiredTitle(),
					message: m.inviteSubExpiredMessage(),
					buttons: [
						{ id: "ok", text: m.inviteSubExpiredBtnOk() },
						{ id: "invite", text: m.inviteSubExpiredBtnInvite() },
					],
				})

				if (buttonId === "invite") {
					sendNotificationResponse("subscription", "opened", notification_id)
					inviteFriend()
				} else {
					sendNotificationResponse("subscription", "closed", notification_id)
				}
				break
			}
		}
	},
	route: () => ({ to: "/home" }),
	routePopup: null,
})
